import dClient, { clientNoLoader } from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initUserForm, setUsers} from "./userSlice";


export const getUsers = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient('get', 'admin/user', {}, {},2, false);
    if (failStatus(res, dispatch)) return '';
    dispatch(setUsers(res.data.data));
    return callback && callback(res);
};

export const getUsersByLastName = (x, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await clientNoLoader('get', `admin/user?last_name=${x}`, {}, {},2, false);
    if (failStatus(res, dispatch)) return '';
    dispatch(setUsers(res.data.data));
    return callback && callback(res);
};

export const getUserById = ({id}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `admin/user/${id}`,
        {},
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(initUserForm(res.data.data))
    return callback && callback();
};

export const createUser = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/user`,
        data,
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editUser = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/user/${id}`,
        data,
        {},
        2,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteUser = ({ user_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `admin/user/${user_id}`,
        {},
        {},
        2,
        true,
    );
    if (failStatus(res,dispatch)) return '';
    return callback && callback(res);
};